const TweetDB = [
  {
    id: (Math.random() * 1000).toFixed(2),
    img: "daniel.jpeg",
    name: "Olowoniyi Daniel",
    username: "Iamdanztee",
    time: "30m",
    tweet: `JavaScript Modules [A THREAD👇]

    JavaScript modules allow you to break up your code into separate files.
    
    This makes it easier to maintain the code-base.
    
    JavaScript modules rely on the import and export statements.`,

    comment: "23",
    retweet: "45",
    like: "186",
  },

  {
    id: (Math.random() * 1000).toFixed(2),
    img: "zul.jpeg",
    name: "Zulkifli",
    username: "tech_contractor",
    time: "1h",
    tweet: `Don’t limit yourself to a certain library or framework. Eventually, the next big thing will come and sweep them off. Focus instead on what changes slowly. React/Vue / Tailwind CSS will disappear but the browser/HTML/CSS and JS will not.`,
    comment: "45",
    retweet: "125",
    like: "206",
  },
  {
    id: (Math.random() * 1000).toFixed(2),
    img: "eniola.jpeg",
    name: "Eniola💫codes",
    username: "EniolaCodes",
    time: "2h",
    tweet: `Let’s learn to listen to others properly, even if it’s something you already know, you might learn a thing
            Be humble & ask questions, you won’t lose anything
            
            Also, Get comfortable being the dumbest developer in the room, use it as an opportunity to learn
            
            Growth is a mindset!🚀`,

    comment: "29",
    retweet: "40",
    like: "100",
  },
  {
    id: (Math.random() * 1000).toFixed(2),
    img: "akin.jpeg",
    name: " Àgbà Akin",
    username: "Kynsofficial",
    time: "3h",
    tweet: `UI/UX Designers actually do much more than we give them credit 
    Love and respect to all designers out there ❤️.`,

    comment: "10",
    retweet: "23",
    like: "83",
  },
  {
    id: (Math.random() * 1000).toFixed(2),
    img: "apt.jpeg",
    name: "aptLearn",
    username: "@aptlearn_io",
    time: "5h",
    tweet: `Frontend: HTML, CSS, JavaScript, React

            Backend: Python, Node.Js, Ruby, Java, PHP
            
            Database: Mysql, MongoDB, Oracle, PostgreSQL
            
            Cloud: AWS, Azure, Google Cloud, Digital Ocean
            
            UI/UX: Figma, Adobe XD, User Experience .`,
    comment: "12",
    retweet: "15",
    like: "90",
  },
  {
    id: (Math.random() * 1000).toFixed(2),
    img: "madza.jpeg",
    name: "Madza 👨‍💻⚡",
    username: "madzadev",
    time: "5h",
    tweet: `What are your favorite YouTube channels for learning JavaScript? 👨‍💻👩‍💻`,
    comment: "52",
    retweet: "15",
    like: "65",
  },
  {
    id: (Math.random() * 1000).toFixed(2),
    img: "petty.jpeg",
    name: "Petty Developer 👨‍💻",
    username: "ibroraheem",
    time: "8h",
    tweet: `As a backend developer, how will I show my work? #NodeJS #backend #webdev`,
    comment: "10",
    retweet: "14",
    like: "92",
  },

  {
    id: (Math.random() * 1000).toFixed(2),
    img: "devsuite.jpeg",
    name: "Devsuite #KBTC22",
    username: "Dev_suite",
    time: "10h",
    tweet: `Go big 🚀📈 or go home 🏡...`,
    comment: "31",
    retweet: "72",
    like: "103",
  },
  {
    id: (Math.random() * 1000).toFixed(2),
    img: "kb.jpeg",
    name: "KwaraBuild | #KBTC22🚀",
    username: "kwarabuild",
    time: "12h",
    tweet: `A new week, another opportunity for you to know that you can do anything you put your mind too.`,
    comment: "12",
    retweet: "10",
    like: "55",
  },
  {
    id: (Math.random() * 1000).toFixed(2),
    img: "code.jpeg",
    name: "Code💭#KBTC22",
    username: "whitecoode",
    time: "12h",
    tweet: `After build comes Bugs😑. #Bug #build #ERROR`,
    comment: "30",
    retweet: "55",
    like: "123",
  },

  {
    id: (Math.random() * 1000).toFixed(2),
    img: "des.jpeg",
    name: " Your Designer",
    username: "Daviowhite",
    time: "13h",
    tweet: `If google ux course took you 1 - 3 months to complete then you didn’t learn anything. 👍🏿`,
    comment: "64",
    retweet: "102",
    like: "345",
  },
  {
    id: (Math.random() * 1000).toFixed(2),
    img: "roman.jpeg",
    name: "Roman Morokhovskyi",
    username: "DevMoroh",
    time: "15h",
    tweet: `Hey developers! What do you prefer, clean and readable code or working code?`,
    comment: "8",
    retweet: "23",
    like: "67",
  },

  {
    id: (Math.random() * 1000).toFixed(2),
    img: "kamal.jpeg",
    name: "Kamaldeen Kehinde #KBTC22",
    username: "ken...",
    time: "18h",
    tweet: `Put in the hard work first, then wait for a miracle.`,
    comment: "45",
    retweet: "72",
    like: "199",
  },

  {
    id: (Math.random() * 1000).toFixed(2),
    img: "sam.jpeg",
    name: "SV D Curious Software Engineer",
    username: "Sam...",
    time: "18h",
    tweet: `Day 22.
    Built a C# console app for calculating area and perimeter of circle.`,
    comment: "22",
    retweet: "50",
    like: "103",
  },
];

export default TweetDB;
